import { render, staticRenderFns } from "./ReportesNomina.vue?vue&type=template&id=90d61ee4&scoped=true"
import script from "./ReportesNomina.vue?vue&type=script&lang=js"
export * from "./ReportesNomina.vue?vue&type=script&lang=js"
import style0 from "./ReportesNomina.vue?vue&type=style&index=0&id=90d61ee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d61ee4",
  null
  
)

export default component.exports